/// <reference path="pages-main.js"/>
/// <reference path="pages.js"/>

function ParseLocalCopyModifyDate(modifyDate) {
  var timedateSeparatorIndex = modifyDate.indexOf(" ");
  var timePart = modifyDate.substring(timedateSeparatorIndex + 1);
  var datePart = modifyDate.substring(0, timedateSeparatorIndex);

  var monthSeparatorIndex = datePart.indexOf("/");
  var daySeparatorIndex = datePart.lastIndexOf("/");
  var month = datePart.substring(0, monthSeparatorIndex);
  var day = datePart.substring(monthSeparatorIndex+1, daySeparatorIndex);
  var year = datePart.substring(daySeparatorIndex+1);

  var hoursSeparatorIndex = timePart.indexOf(":");
  var minsSeparatorIndex = timePart.lastIndexOf(":");
  var hours = timePart.substring(0, hoursSeparatorIndex);
  var mins = timePart.substring(hoursSeparatorIndex + 1, minsSeparatorIndex);
  var secs = timePart.substring(minsSeparatorIndex + 1);

  return new Date(year, month-1, day, hours, mins, secs, 0);
}

//Возвращает размер документа в виде строки.
function GetDocumentSizeAsString(sizeB) {
  var sizeMB = Math.floor(sizeB / (1024 * 1024));
  var sizeKB = Math.floor(sizeB / 1024);
  if (sizeMB > 0) {
    return sizeMB + " " + L("SIZE_POSTFIX_MBYTES");
  } else if (sizeKB > 0) {
    return sizeKB + " " + L("SIZE_POSTFIX_KBYTES");
  } else {
    return sizeB + " " + L("SIZE_POSTFIX_BYTES");
  }
}

//Отображает модальное окно с выбором действий при открытии документа, у которого есть локальная копия.
function AskForActionOnDocument(Doc, LocalCopies, Lock) {
  var hasOnlyOneCopy = LocalCopies.length == 1;
  var actions = [L('RECOVER_FROM_LOCAL_COPY'), L('OPEN_DOC_AND_DELETE_LOCAL_COPY'), L('GO_TO_DOCUMENT_RECOVERY')];
  var documentVersion = null;
  for (var i = 0; i < Doc.Versions.length; ++i) {
    if (Doc.Versions[i].Number == LocalCopies[0].Version);
    documentVersion = Doc.Versions[i];
  }

  var localCopyModifyDate = ParseLocalCopyModifyDate(LocalCopies[0].EditDate);
  var documentModifyDate = parseDateTime(documentVersion.LastModifiedText);
  var message = format(hasOnlyOneCopy ? (L("DOCUMENT_HAS_LOCAL_COPY").replaceAll("\\\\n", "<br>")) : L("DOCUMENT_HAS_MULTIPLE_LOCAL_COPIES"), {
    0: Doc.ClientName,
    1: formatDateTime(documentModifyDate),
    2: formatDateTime(localCopyModifyDate),
    3: GetDocumentSizeAsString(documentVersion.Size),
    4: GetDocumentSizeAsString(LocalCopies[0].Size)
  });
  var html = '<div id="actionOnDocumentForm">';
  html += '<div id="actionOptionsGroup">';
  html += '<div id="optionsTitle">' + L('LOCAL_COPY_OPTIONS') + '</div>';
  html += '<div id="actionOptions">';
  for (var i = 0; i < actions.length; i++) {
    var needCheck = (i == 0 && hasOnlyOneCopy) || (i == 2 && !hasOnlyOneCopy);
    html += '<div class="option">'
      + '<input id="option-' + i + '" type="radio" name="actions"' + (needCheck ? 'checked ' : '') + (hasOnlyOneCopy ? '' : ' disabled="disabled"') + ' opcode="' + i + '" />'
      + '<label for="option-' + i + '" ' + (hasOnlyOneCopy ? '' : 'class="field_disabled"') + '>' + actions[i] + '</label></div>';
  }
  html += '</div></div></div>';

  LocalCopyRecommendedAction[(LocalCopies[0].ID + 'v' + LocalCopies[0].Version)] = localCopyModifyDate > documentModifyDate ? "RECOVER" : "DELETE";

  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = 600;
  mbox.okCancelButtons(function () {
    var opcode = $('#actionOptions').find('input:checked').attr('opcode');
    switch (opcode) {
      case "0": ReturnLocalCopy(Doc.ID, LocalCopies[0].Version, Doc.Encoding, Doc.PluginName, GetFileNameFromDoc(Doc, LocalCopies[0].Version), LocalCopies[0].EditDate); break;
      case "1":
        DeleteLocalCopy(Doc.ID, LocalCopies[0].Version, function () {
          OpenWithAgent({ id: Doc.ID }, Lock);
        });
        break;
      case "2": WebAccess.agent.edms.checkDocumentLocalCopies(); break;
    }
  }, null);
  mbox.showWarning(message, html);
  BindHelpIcoClickOnModalWindow('RestoreDocuments', $('#dialog_content_' + mbox.id).parents('.ui-dialog'));
}

function GetFileNameFromDoc(Doc, Version) {
  var ext = Doc.Editor.Extension; ;
  if (!!Version) {
    var verIndex = -1;
    for (var i = 0; i < Doc.Versions.length; i++) {
      if (Doc.Versions[i].Number == Version) { verIndex = i; break; }
    }
    ext = Doc.Versions[verIndex].Editor.Extension;
  }
  return Doc.ClientName + '.' + ext.toLowerCase();
}

function ExportCert(el) {
  var jEl = $(el);
  var certid = jEl.attr('data-certid');
  var docId = WA.current.ID;
  var verNum = jEl.attr('data-vernum');
  if (certid === "") {
    ShowError(format(L("ERR_INVALID_SIGN"), verNum, WA.current.ClientName));
  } else {
    window.location.href = "DynControl.ashx?c=export_certificate&certid=" + certid + "&docid=" + docId + "&verNum=" + verNum;
  }
}
